import { render, staticRenderFns } from "./starIcon.vue?vue&type=template&id=047d9670&"
import script from "./starIcon.vue?vue&type=script&lang=ts&"
export * from "./starIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports